/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

/*Import Requisição API*/
import api from '../../../../api';
import { useAuth } from '../../../../context/AuthContext';
import { useCart } from '../../../../context/CartContext';
import { useToast } from '../../../../context/ToastContext';

export default function MeusPedidos() {
  const { userId } = useAuth();
  const { atualizarCarrinho } = useCart();
  const { showToast } = useToast();
  const [pedidos, setPedidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pedidoConfirmacao, setPedidoConfirmacao] = useState(null);
  const [recomprando, setRecomprando] = useState(false);
  const caixaConfirmacaoRef = useRef(null);

  const abrirConfirmacaoRecompra = (pedidoId) => {
    setPedidoConfirmacao(pedidoId);
    caixaConfirmacaoRef.current?.showModal();
  };

  const fecharConfirmacaoRecompra = () => {
    caixaConfirmacaoRef.current?.close();
    setPedidoConfirmacao(null);
  };

  useEffect(() => {
    const fetchPedidos = async () => {
      if (!userId) return;

      try {
        setLoading(true);
        const response = await api.get(`/usuario/${userId}/pedidos`, { withCredentials: true });

        if (response.data.success) {
          // Filtrar rascunhos para não mostrar ao cliente
          const pedidosFiltered = response.data.data.filter(pedido => pedido.status_pedido !== 'Rascunho');
          setPedidos(pedidosFiltered);
        }
      } catch (error) {
        console.error('Erro ao buscar pedidos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPedidos();
  }, [userId]);

  const getStatusColor = (status) => {
    const statusColors = {
      'Rascunho': '#9E9E9E',
      'Pedido Efetuado': '#4CAF50',
      'Separado': '#2196F3',
      'Incompleto': '#FF9800',
      'Em Processamento': '#9C27B0',
      'Enviado': '#00BCD4',
      'Entregue': '#8BC34A',
      'Pago': '#4CAF50',
      'Cancelado': '#F44336',
      'Excluído': '#9E9E9E'
    };
    return statusColors[status] || '#757575';
  };

  const handleRecomprar = async () => {
    if (!pedidoConfirmacao) return;

    try {
      setRecomprando(true);
      await api.post(`/usuario/${userId}/pedidos/${pedidoConfirmacao}/recomprar`, {}, { withCredentials: true });
      await atualizarCarrinho();
      showToast('Itens adicionados ao carrinho para recompra!', 'success');
      fecharConfirmacaoRecompra();
    } catch (error) {
      console.error('Erro ao recomprar:', error);
      showToast('Nao foi possivel recomprar esse pedido.', 'error');
    } finally {
      setRecomprando(false);
    }
  };

  return (
    <section className='container-principal-meus-pedidos'>
      <dialog id='CaixaConfirmacaoRecompra' ref={caixaConfirmacaoRef}>
        <div className='conteudo-dialog'>
          <div className='dialog-texto'>
            <p>Tem certeza que deseja adicionar novamente os itens deste pedido ao carrinho?</p>
            <div className='acoes-dialog'>
              <button type='button' className='btn-cancelar' onClick={fecharConfirmacaoRecompra} disabled={recomprando}>
                Cancelar
              </button>
              <button type='button' className='btn-confirmar' onClick={handleRecomprar} disabled={recomprando}>
                {recomprando ? 'Adicionando...' : 'Confirmar'}
              </button>
            </div>
          </div>
        </div>
      </dialog>

      <Cabecalho />
      <CookieAceite />

      <main>
        <MenuLateral />

        <section className='conteudo-meus-pedidos'>
          <div className='titulo-pedidos'>
            <h1><span>Perfil</span> &gt; Meus Pedidos</h1>
          </div>

          <BtnVoltar />

          <div className='lista-pedidos'>
            {loading ? (
              <div className='loading-pedidos'>
                <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24'>
                  <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                  <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                  </path>
                </svg>
                <h2>Carregando pedidos...</h2>
              </div>
            ) : pedidos.length > 0 ? (
              pedidos.map((pedido) => (
                <div key={pedido.id} className='pedido-card'>
                  <div className='pedido-header'>
                    <div className='pedido-info'>
                      <h2>Pedido #{pedido.id}</h2>
                      <p className='pedido-data'>
                        {new Date(pedido.data_pedido).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: 'long',
                          year: 'numeric'
                        })}
                      </p>
                    </div>
                    <div className='pedido-status' style={{ backgroundColor: getStatusColor(pedido.status_pedido) }}>
                      {pedido.status_pedido}
                    </div>
                  </div>

                  <div className='pedido-detalhes'>
                    <div className='pedido-resumo'>
                      <div className='resumo-item'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className='resumo-texto'>
                          <span className='resumo-label'>Itens</span>
                          <span className='resumo-valor'>{pedido.total_itens || 0}</span>
                        </div>
                      </div>
                      
                      <div className='resumo-item'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="#131C46"/>
                        </svg>
                        <div className='resumo-texto'>
                          <span className='resumo-label'>Status</span>
                          <span className='resumo-valor'>{pedido.status_pagamento || 'Pendente'}</span>
                        </div>
                      </div>

                      <div className='resumo-item'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 10H21M7 15H8M12 15H13M6 19H18C19.1046 19 20 18.1046 20 17V7C20 5.89543 19.1046 5 18 5H6C4.89543 5 4 5.89543 4 7V17C4 18.1046 4.89543 19 6 19Z" stroke="#131C46" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <div className='resumo-texto'>
                          <span className='resumo-label'>Pagamento</span>
                          <span className='resumo-valor'>{pedido.metodo_pagamento || 'Não informado'}</span>
                        </div>
                      </div>

                      <div className='resumo-item'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V19.5H10.74V18.07C9.42 17.77 8.25 17.04 7.84 15.57L9.61 14.84C9.87 15.78 10.57 16.5 12.03 16.5C13.37 16.5 14.03 15.85 14.03 15.07C14.03 14.17 13.37 13.66 11.64 13.13C9.58 12.5 8.13 11.5 8.13 9.64C8.13 8.08 9.29 6.92 10.74 6.55V5H13.41V6.57C14.73 6.94 15.54 7.82 15.84 9.03L14.09 9.74C13.87 8.92 13.31 8.3 12.03 8.3C10.87 8.3 10.13 8.87 10.13 9.64C10.13 10.43 10.82 10.86 12.38 11.33C14.42 11.94 16.03 12.78 16.03 15.04C16.03 16.64 14.88 17.73 13.41 18.09Z" fill="#131C46"/>
                        </svg>
                        <div className='resumo-texto'>
                          <span className='resumo-label'>Valor Total</span>
                          <span className='resumo-valor'>R$ {Number(pedido.valor_total).toFixed(2)}</span>
                        </div>
                      </div>
                    </div>

                    <Link to={`/menu/perfil/meuspedidos/${pedido.id}`} className='bnt-ver-pedido'>
                      Ver Detalhes Completos
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </Link>
                    <button type='button' className='bnt-ver-pedido' onClick={() => abrirConfirmacaoRecompra(pedido.id)}>
                      Recompra Rapida
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.25 10A6.25 6.25 0 1 1 14.42 5.58" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M16.25 3.75V10H10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className='sem-pedidos'>
                <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M60 110C87.6142 110 110 87.6142 110 60C110 32.3858 87.6142 10 60 10C32.3858 10 10 32.3858 10 60C10 87.6142 32.3858 110 60 110Z" stroke="#E0E0E0" strokeWidth="5" />
                  <path d="M40 55C40 52.2386 42.2386 50 45 50H75C77.7614 50 80 52.2386 80 55V80C80 82.7614 77.7614 85 75 85H45C42.2386 85 40 82.7614 40 80V55Z" stroke="#E0E0E0" strokeWidth="5" />
                  <path d="M50 50V40C50 34.4772 54.4772 30 60 30V30C65.5228 30 70 34.4772 70 40V50" stroke="#E0E0E0" strokeWidth="5" strokeLinecap="round" />
                </svg>
                <h2>Nenhum pedido encontrado</h2>
                <p>Você ainda não realizou nenhuma compra.</p>
                <Link to="/produtos" className='bnt-comprar'>
                  Começar a Comprar
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>

      <Rodape />
    </section>
  );
}